import React from 'react'
import { VictoryContainer, VictoryLegend } from 'victory'
import PieChart from './PieChart'
import { red, green, orange, yellow } from '@material-ui/core/colors'
import ChartTooltip from './ChartTooltip'

const NestedPieChart = ({
  width = 300,
  height = 300,
  data,
  dataOuter,
  dataInner,
  categories,
  theme,
  translate = 27.5
}) => {
  return (
    <svg width={width} height={height}>
      <VictoryLegend
        standalone={false}
        orientation='horizontal'
        colorScale={[green[500], red[500]]}
        data={[{ name: 'Correct' }, { name: 'Misclassified' }]}
      />
      <g
        style={{ transformOrigin: 'center', transform: `translatey(${20}px)` }}
      >
        <VictoryLegend
          standalone={false}
          orientation='horizontal'
          gutter={5}
          padding={{ top: 20, bottom: 60 }}
          colorScale={[green[500], yellow[500], orange[500], red[500]]}
          data={[
            { name: 'Class 1' },
            { name: 'Class 2' },
            { name: 'Class 3' },
            { name: 'Class 4' }
          ]}
        />
      </g>
      <PieChart
        animate={true}
        standalone={false}
        width={width}
        height={height}
        innerRadius={75}
        data={dataOuter}
        categories={categories}
        theme={theme}
        colorScale={[green[500], red[500]]}
        labels={d => `${d.x}: ${d.y}`}
        labelComponent={<ChartTooltip />}
      />
      <g
        style={{
          transformOrigin: 'center',
          transform: `translatex(${translate}px) translatey(${translate}px)`
        }}
      >
        <PieChart
          animate={true}
          standalone={false}
          width={245}
          height={245}
          data={dataInner}
          categories={categories}
          theme={theme}
          containerComponent={<VictoryContainer responsive={false} />}
          colorScale={[green[500], yellow[500], orange[500], red[500]]}
          labels={d => `${d.x}: ${d.y}`}
          labelComponent={<ChartTooltip />}
        />
      </g>
    </svg>
  )
}

export default NestedPieChart



// WEBPACK FOOTER //
// ./src/charts/NestedPieChart.js